import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide } from "@cinch-labs/design-system";
import OurCommitmentSlide from "../slides/our-commitment-slide";
import styles from "./our-commitment-carousel.module.css";
var OurCommitmentCarousel = function(param) {
    var slides = param.slides;
    var backgroundColors = [
        "#8C32BE",
        "#5234B6",
        "#311C77"
    ];
    var carouselName = "cinch-commitment";
    var navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    var navCustomClasses = {
        prevButton: styles["prevButton"],
        nextButton: styles["nextButton"]
    };
    var swiperSettings = {
        loop: true
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "ourCommitment",
        children: [
            /*#__PURE__*/ _jsx(Carousel, {
                name: carouselName,
                swiperSettings: swiperSettings,
                children: slides.map(function(slide, idx) {
                    return /*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _createElement(OurCommitmentSlide, _object_spread_props(_object_spread({}, slide), {
                            key: slide.title,
                            backgroundColor: backgroundColors[idx % backgroundColors.length]
                        }))
                    }, idx);
                })
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles["controlsWrapper"],
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselName,
                        customClassNames: styles["customPagination"]
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        customClassNames: navCustomClasses
                    })
                ]
            })
        ]
    });
};
export default OurCommitmentCarousel;
